import { put, call, takeEvery, all } from 'redux-saga/effects';

import * as actions from '@actions/organization';
import { createAccount, getAccount, updateAccount, listOrgStr } from '@api/organization';
import types from '@constants/action-types';

export const handleListOrgStrRequest = function* ({ payload }) {
  try {
    const response = yield call(listOrgStr, payload);
    if (response.isAxiosError) return yield put(actions.orgStrListFailure(response.message));
    yield put(actions.orgStrListSuccess(response));
  } catch (e) {
    yield put(actions.orgStrListFailure(e));
  }
};

export const handleCreateAccountRequest = function* ({ payload }) {
  try {
    const response = yield call(createAccount, payload);
    if (response.isAxiosError) return yield put(actions.createAccountFailure(response.message));
    yield put(actions.createAccountSuccess(response));
  } catch (e) {
    yield put(actions.createAccountFailure(e));
  }
};

export const handleGetAccountRequest = function* ({ payload }) {
  try {
    const response = yield call(getAccount, payload);
    if (response.isAxiosError) return yield put(actions.getAccountFailure(response.message));
    yield put(actions.getAccountSuccess(response));
  } catch (e) {
    yield put(actions.getAccountFailure(e));
  }
};

export const handleUpdateAccountRequest = function* ({ payload }) {
  try {
    const response = yield call(updateAccount, payload.id, payload.payload);
    if (response.isAxiosError) return yield put(actions.updateAccountFailure(response.message));
    yield put(actions.updateAccountSuccess(response));
  } catch (e) {
    yield put(actions.updateAccountFailure(e));
  }
};

export default all([
  takeEvery(types.CREATE_ACCOUNT_REQUEST, handleCreateAccountRequest),
  takeEvery(types.GET_ACCOUNT_REQUEST, handleGetAccountRequest),
  takeEvery(types.UPDATE_ACCOUNT_REQUEST, handleUpdateAccountRequest),
  takeEvery(types.ORG_STR_LIST_REQUEST, handleListOrgStrRequest),
]);
